import Carousel from '@/components/ui/Carousel';
import { Page_Pagebuilder_Blocks_Gallery } from '@/graphql/generated/graphql';
import { getContainerClass } from 'utils/helpers';

const GalleryBlock = ({
  blockId,
  galleryItems,
  containerWidth,
}: Page_Pagebuilder_Blocks_Gallery) => {
  return (
    <section id={blockId ?? undefined} className="w-full my-14 lg:my-24">
      <div
        className={`w-full h-[85vh] lg:min-h-[700px] ${getContainerClass(containerWidth)}`}
      >
        <Carousel slides={galleryItems} />
      </div>
    </section>
  );
};

export default GalleryBlock;
